"use client";

import { useState } from "react";
import { NOTE_UI } from "@/lib/note/copy";

/** 노트 상세 이미지 넘김 (최대 3장). 이미지가 없으면 아무것도 렌더하지 않는다. */
export default function NoteImageCarousel({ images, alt }: { images: string[]; alt: string }) {
  const list = images.slice(0, 3);
  const [i, setI] = useState(0);
  if (list.length === 0) return null;
  const go = (d: number) => setI((v) => (v + d + list.length) % list.length);

  return (
    <div className="mt-6" data-testid="note-carousel">
      <div className="relative overflow-hidden" style={{ borderRadius: 12, background: "#F6F6F7" }}>
        {/* eslint-disable-next-line @next/next/no-img-element -- Storage URL (remotePatterns 미설정) */}
        <img src={list[i]} alt={alt} className="block w-full h-auto" />
        {list.length > 1 && (
          <>
            <button
              type="button"
              onClick={() => go(-1)}
              aria-label={NOTE_UI.prevImage}
              className="absolute left-2 top-1/2 -translate-y-1/2"
              style={{ width: 36, height: 36, borderRadius: 999, background: "rgba(255,255,255,0.9)", color: "#1C1A19", fontSize: 18 }}
            >
              ‹
            </button>
            <button
              type="button"
              onClick={() => go(1)}
              aria-label={NOTE_UI.nextImage}
              className="absolute right-2 top-1/2 -translate-y-1/2"
              style={{ width: 36, height: 36, borderRadius: 999, background: "rgba(255,255,255,0.9)", color: "#1C1A19", fontSize: 18 }}
            >
              ›
            </button>
          </>
        )}
      </div>
      {list.length > 1 && (
        <div className="mt-2 text-center text-[color:var(--color-meta)]" style={{ fontSize: 12, fontFamily: "var(--font-en)" }}>
          {i + 1} / {list.length}
        </div>
      )}
    </div>
  );
}
